// components/LoadingSpinner.jsx
import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ message = "Loading adventure...", size = "medium" }) => {
  return (
    <div className="generic-loader-container">
      <div className={`spinner-ring ${size}`}>
        <div className="spinner-dot"></div>
      </div>
      {message && <p className="spinner-text">{message}</p>}
    </div>
  );
};

export default LoadingSpinner;